import React from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert } from "flowbite-react";
import { HiCheckCircle, HiXCircle } from "react-icons/hi";
import { FaRegThumbsDown, FaRegThumbsUp } from "react-icons/fa6";
import { getImageURLScore } from "../../../utils/utils";

// Cor com base em thresholds
const getColorClass = (value, thresholds) => {
  if (value >= thresholds.green) return "text-green-600";
  if (value >= thresholds.yellow) return "text-yellow-500";
  return "text-red-600";
};

// Texto explicativo do Rating Bacen
const getRatingDescription = (rating) => {
  switch (rating) {
    case "AA":
      return "Perfil de crédito excelente. Muito baixa probabilidade de risco.";
    case "A":
      return "Bom histórico de crédito. Baixa probabilidade de inadimplência.";
    case "B":
      return "Perfil estável, mas com atenção a eventuais riscos.";
    case "C":
      return "Algum risco percebido. Crédito pode exigir mais garantias.";
    case "D":
    case "E":
    case "F":
    case "G":
      return "Alto risco de inadimplência. Revisão e garantias são esperadas.";
    case "H":
      return "Muito alto risco. Operação geralmente considerada irrecuperável.";
    default:
      return "Classificação não informada ou fora do padrão.";
  }
};

// Renderização de faixa de renda
const renderRenda = ({ min, max }) => {
  if (min && max) {
    return `R$ ${min.toLocaleString()} até R$ ${max.toLocaleString()}`;
  } else if (min) {
    return `Acima de R$ ${min.toLocaleString()}`;
  } else if (max) {
    return `Até R$ ${max.toLocaleString()}`;
  } else {
    return "Não informado";
  }
};

const ScorePFQuery = ({ data }) => {
  return (
    <>
      <TitleStripe>Score de crédito</TitleStripe>

      {data?.statusRetorno == 1 ? (
        <div className="grid grid-cols-3 gap-4 mt-3">
          <div className="bg-white rounded-2xl border border-gray-300 p-6 grid grid-cols-1 md:grid-cols-2 gap-6 col-span-2">
            {/* SCORE */}
            <div className="flex gap-6">
              <div>
                <p className="text-sm text-gray-500">Score</p>
                <p
                  className={`text-4xl font-bold ${getColorClass(data?.valor, {
                    green: 800,
                    yellow: 600,
                  })}`}
                >
                  {data?.valor}
                </p>
                <p className="text-sm text-gray-600 mt-1">
                  {data.categoriaScore}
                </p>
              </div>
            </div>

            {/* RATING BACEN */}
            <div>
              <p className="text-sm text-gray-500">Rating Bacen</p>
              <p className="text-2xl font-semibold text-blue-700">
                {data.ratingBACEN}
              </p>
              {/* <p className="text-sm text-gray-500 mt-1 italic">
              {getRatingDescription(data.ratingBACEN)}
            </p> */}
              <p className="text-sm text-gray-600 mt-1">
                Probabilidade de inadimplência:{" "}
                <span
                  className={`font-medium ${getColorClass(
                    data.probabilidadeInadimplencia,
                    { green: 0, yellow: 11 }
                  )}`}
                >
                  {data.probabilidadeInadimplencia}%
                </span>
              </p>
            </div>

            {/* CAPACIDADE DE PAGAMENTO */}
            <div>
              <p className="text-sm text-gray-500">Capacidade de Pagamento</p>
              <p
                className={`text-lg font-semibold ${getColorClass(
                  data.capacidadePagamento,
                  { green: 80, yellow: 50 }
                )}`}
              >
                {data.capacidadePagamento}%
              </p>
            </div>

            {/* CONCESSÃO DE CRÉDITO */}
            <div>
              <p className="text-sm text-gray-500">Concessão de Crédito</p>
              <div className="flex items-center gap-2 mt-1">
                {data.concessaoCredito ? (
                  <>
                    <FaRegThumbsUp className="text-green-600 w-5 h-5" />
                    <span className="text-green-600 font-medium">
                      Recomendada
                    </span>
                  </>
                ) : (
                  <>
                    <FaRegThumbsDown className="text-red-600 w-5 h-5" />
                    <span className="text-red-600 font-medium">
                      Não Recomendada
                    </span>
                  </>
                )}
              </div>
            </div>

            {/* RENDA PRESUMIDA */}
            <div>
              <p className="text-sm text-gray-500">Renda Presumida</p>
              <p className="text-md text-gray-800 font-semibold">
                {renderRenda(data?.rendaPresumidaEstimada)}
              </p>
            </div>

            {/* RENDA FAMILIAR ESTIMADA */}
            <div>
              <p className="text-sm text-gray-500">Renda Familiar Estimada</p>
              <p className="text-md text-gray-800 font-semibold">
                {renderRenda(data?.rendaFamiliarEstimada)}
              </p>
            </div>
          </div>
          <div className="bg-white rounded-2xl border border-gray-300 p-2 flex flex-col items-star justify-center">
            <img className="w-full" src={`${getImageURLScore(+data?.valor)}`} />
            <p
              className={`text-4xl text-center font-bold ${getColorClass(
                data?.valor,
                {
                  green: 800,
                  yellow: 600,
                }
              )}`}
            >
              {data?.valor}
            </p>
          </div>
        </div>
      ) : (
        <Alert withBorderAccent color="gray" className="mt-4">
          Consulta Indisponível no momento
        </Alert>
      )}
    </>
  );
};

export default ScorePFQuery;
